import SortableList from './SortableList';

const SortableComponent = ({
  items,
  onDragEnd,
  onDelete,
  canDelete = true,
  canReorder = true,
}) => {
  return (
    <SortableList
      items={items}
      onDelete={onDelete}
      onDragEnd={onDragEnd}
      canDelete={canDelete}
      canReorder={canReorder}
      helperClass="dragging-sortable-item"
    />
  );
};

export default SortableComponent;
